import {CnxPartitioner} from '../../partitioner/message/CnxPartitioner';
import {CnxProcessor} from '../../processor/message/CnxProcessor';
import {CnxReader} from './CnxReader';
import {CnxWriter} from './CnxWriter';
import {EngineOperation} from '../../engineparam/message/EngineOperation';

export class StepParameter {
chunkSize: number | null;
engines: EngineOperation[];
partitioner: CnxPartitioner;
predefinedParams: Object;
processor: CnxProcessor;
reader: CnxReader;
writer: CnxWriter;
}

